import { createFileRoute } from "@tanstack/react-router";
import { Compliance } from "@/components/Compliance";

function RouteComponent() {
  return <Compliance />;
}

export const Route = createFileRoute("/_authenticated/compliance/")({
  component: RouteComponent,
  staticData: { page: "compliance" },
});
